import React, { useLayoutEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { Spacer } from '@nextui-org/react'

import Tabs from '@/components/atoms/Tabs'
import FanmeLoading from '@/components/atoms/FanmeLoading'
import HeadeLine from '@/components/atoms/HeadLine'
import ThemeChanger from '@/components/molecules/ThemeChanger'
import CreatorCoverType from '@/components/molecules/Profile/CreatorCoverType'
import CreatorHeaderImage from '@/components/molecules/Profile/CreatorHeaderImage'
import PageEditToggleButton from '@/components/molecules/PageEditToggleButton'

import { useThemeContext } from '@/contexts/ThemeContext'

import { Colors } from '@/constants/styles/color'
import { Covers, Resource, THEMES } from '@/types/Creator.type'

import { useFanmeBackendGet, useUser } from '@/libs/fanme_backend'
import { putForm } from '@/pages/api/base'
import { useCurrentUser } from '@/contexts/AuthContext'
import styles from './style.module.scss'

const ProfileEdit = () => {
  const router = useRouter()
  const { refreshCurrentUser } = useCurrentUser()
  const themeCtx = useThemeContext()
  const [cover, setCover] = useState('')
  const [covers, setCovers] = useState<Covers>(Object)

  const { data: loginUser } = useUser()
  const { data: profile, mutate: mutateProfile } = useFanmeBackendGet<any>(
    '/fanme/api/creators/self/profile',
    {
      auth: true,
    },
  )

  useLayoutEffect(() => {
    if (profile) {
      // const themeType = profile.theme_color
      // themeCtx.setCtxTheme(themeType)
      if (profile.covers) {
        setCovers(profile.covers)
        if (profile.covers?.resources) {
          profile.covers.resources.map((resource: Resource) => {
            if (resource.displayable === true) {
              setCover(resource.resource)
            }
          })
        }
      }
      refreshCurrentUser()
    }
  }, [profile])

  /**
   * 背景カラーを更新する
   * @param theme テーマ THEMESの任意の値
   */
  const onChangeTheme = async (theme: THEMES) => {
    const form = new FormData()
    form.append('color', theme)

    await putForm('/creators/self/profile_theme_color', form)
    await refreshCurrentUser()
  }

  return (
    <>
      {(!profile || !loginUser) && <FanmeLoading />}
      <div
        className={styles.viewCover}
        style={{
          backgroundImage: `url(${cover})`,
          backgroundColor: `${cover ? 'none' : Colors.BK_GRAY}`,
        }}
      >
        <div className={styles.toggleButton}>
          <PageEditToggleButton creatorId={loginUser?.account_identity} isEdit={true} />
        </div>
      </div>

      <div
        className={styles.contentsArea}
        style={{
          background: themeCtx.color,
        }}
      >
        <Tabs
          tabs={['ページ編集', 'デザイン設定']}
          onChange={index => index === 0 && router.push('/creator/contents')}
        />

        <div className={styles.contentsAreaBody} id="contentsBody">
          <CreatorCoverType covers={covers} getCoverImage={mutateProfile} />

          <CreatorHeaderImage image={profile?.header_image} />

          <div className={styles.profileBlock}>
            <div className={styles.profileBlockItem}>
              <div className={styles.blockTitleField}>
                <HeadeLine text="背景カラー" textColor={themeCtx.themeColors.text} />
              </div>
              <div className={styles.themeSelect}>
                <div className={styles.cardBase}>
                  <ThemeChanger onChangeTheme={onChangeTheme} currentTheme={themeCtx.theme} />
                </div>
              </div>
            </div>
          </div>
          <Spacer y={5} />
        </div>
      </div>
    </>
  )
}

export default ProfileEdit
